import React from 'react';
import { useTranslation } from 'react-i18next';

const H = ({ tag: Tag = 'p', html, className }) => (
  <Tag className={className} dangerouslySetInnerHTML={{ __html: html }} />
);
const LI = ({ html }) => <li dangerouslySetInnerHTML={{ __html: html }} />;

const Termini = () => {
  const { t } = useTranslation();

  return (
    <div className="legal-page">
      <div className="top-bar" />
      <div className="legal-container">
        <h1 className="legal-title">{t('termini.title')}</h1>
        <p className="legal-update">{t('legal.lastUpdate')}: {t('legal.date')}</p>

        <section className="legal-section">
          <H html={t('termini.intro')} />
        </section>

        <section className="legal-section">
          <h2>{t('termini.s1t')}</h2>
          <H html={t('termini.s1p')} />
        </section>

        <section className="legal-section">
          <h2>{t('termini.s2t')}</h2>
          <H html={t('termini.s2p1')} />
          <H html={t('termini.s2p2')} />
        </section>

        <section className="legal-section">
          <h2>{t('termini.s3t')}</h2>
          <ul>
            <LI html={t('termini.s3l1')} />
            <LI html={t('termini.s3l2')} />
            <LI html={t('termini.s3l3')} />
          </ul>
        </section>

        <section className="legal-section">
          <h2>{t('termini.s4t')}</h2>
          <H html={t('termini.s4intro')} />
          <ul>
            <LI html={t('termini.s4l1')} />
            <LI html={t('termini.s4l2')} />
            <LI html={t('termini.s4l3')} />
            <LI html={t('termini.s4l4')} />
            <LI html={t('termini.s4l5')} />
          </ul>
          <H html={t('termini.s4p')} />
        </section>

        <section className="legal-section">
          <h2>{t('termini.s5t')}</h2>
          <H html={t('termini.s5p')} />
        </section>

        <section className="legal-section">
          <h2>{t('termini.s6t')}</h2>
          <H html={t('termini.s6p')} />
        </section>

        <section className="legal-section">
          <h2>{t('termini.s7t')}</h2>
          <ul>
            <LI html={t('termini.s7l1')} />
            <LI html={t('termini.s7l2')} />
            <LI html={t('termini.s7l3')} />
          </ul>
        </section>

        <section className="legal-section">
          <h2>{t('termini.s8t')}</h2>
          <H html={t('termini.s8p')} />
        </section>

        <section className="legal-section">
          <h2>{t('termini.s9t')}</h2>
          <H html={t('termini.s9p')} />
        </section>

        <section className="legal-section">
          <h2>{t('termini.s10t')}</h2>
          <H html={t('termini.s10p')} />
        </section>
      </div>
    </div>
  );
};

export default Termini;
